<template>
  <div class="pageContol exam-house-dashboard">
    <div class="framePage">
      <!-- <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">考试管理</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">考试大屏</a>
        </span>
      </div> -->
      <div id="dashboard-content" class="framePage-body dashboard-container">
        <div class="dashboard-header">
          <h2>{{ compName + ' 考试仓监控屏' }}</h2>
          <button class="fullscreen-btn" @click="toggleFullScreen">
            <i :class="isFullscreen ? 'el-icon-full-screen' : 'el-icon-full-screen'"></i>
          </button>
        </div>

        <div class="exam-house-grid">
          <div v-for="examHouse in paginatedExamHouseList" :key="examHouse.examHouseId" class="exam-house-card"
            @click="goToMonitor(examHouse)">
            <div :class="{
              'exam-house-card-header-gray': examHouse.houseState === 'OFFLINE' || examHouse.examState === '00',
              'exam-house-card-header': examHouse.examState === '01' && examHouse.houseState !== 'OFFLINE',
              'exam-house-card-header-warn': examHouse.examState === '02' && examHouse.houseState !== 'OFFLINE'
            }">
              <h3>{{ examHouse.houseName }}</h3>
            </div>
            <div class="exam-house-card-body">
              <div class="exam-house-image">
                <img v-if="!examHouse.playUrl" src="@/assets/BG.png">
                <div v-else :id='"ezuikit-player-" + examHouse.examHouseId'></div>
              </div>
              <div v-if="examHouse.lastEvent" class="exam-house-alerts">
                <div class="alert-item">
                  <span class="alert-icon"></span>
                  <span class="alert-text">{{ examHouse.lastEvent.remark }}</span>
                </div>
              </div>
              <div v-else class="exam-house-status normal">
                {{ '正常状态' }}
              </div>
            </div>
            <div class="exam-house-card-footer">
              <span class="device-count">{{ '设备数量' }}: {{ examHouse.deviceCount || 0 }}</span>
          <span class="edge-runner-info">
            {{ '中控状态' }}: {{ edgeRunnerStateText(examHouse.edgeRunnerState) }} | 
            {{ '版本' }}: {{ examHouse.edgeRunnerVer || '-' }}
          </span>
          <span class="view-detail">{{ '查看详情' }} &gt;</span>
            </div>
          </div>
        </div>
        <!-- 分页控制 -->
        <div v-if="totalPages > 1" class="pagination-controls">
          <el-pagination
            @current-change="handlePageChange"
            :current-page="currentPage"
            :page-sizes="[8]"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="examHouseList.length">
          </el-pagination>
        </div>
      </div>
    </div>
    <dialog id="messageDialog">
        <h2>提示</h2>
        <p>{{ messageBox.message }}</p>
    </dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EZUIKit from "ezuikit-js";
import ExamHouse from './examHouse.vue';
export default {
  name: 'ExamHouseDashboard',
  data() {
      return {
        compName: '',
        examHouseList: [],
        loading: false,
        isFullscreen: false,
        // 萤石播放器实例化
        playerVides: {},
        // 定时器ID
        refreshTimer: null,
        // 分页相关
        currentPage: 1,
        pageSize: 8,
        messageBox: {
          defaultCount: 3,
          message: '',
          countdown: 0,
          timer: null
        }
      };
  },
  computed: {
      orgId() {
        return this.$route.params.orgId || '';
      },
      ...mapGetters({
        userJson: "getUser"
      }),
      // 计算分页后的考试仓列表
      paginatedExamHouseList() {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        return this.examHouseList.slice(start, end);
      },
      // 计算总页数
      totalPages() {
        return Math.ceil(this.examHouseList.length / this.pageSize);
      }
    },
  created() {
    // 查询单位名称
    this.getCompany(this.userJson.compId);
    this.loadExamHouseList();
  },
  beforeRouteLeave(to, from, next) {
    // 在路由离开前销毁播放器
    if (this.playerVides && Object.keys(this.playerVides).length) {
      Object.keys(this.playerVides).forEach(examHouseId => {
        this.playerVides[examHouseId].destroy(); // 销毁 萤石 播放器
      });
    }
    next();
  },
    methods: {
      /**
       * 处理分页变化
       */
      handlePageChange(page) {
        this.currentPage = page;
        // 销毁当前页面的播放器
        if (this.playerVides && Object.keys(this.playerVides).length) {
          Object.keys(this.playerVides).forEach(examHouseId => {
            this.playerVides[examHouseId].destroy();
          });
          this.playerVides = {};
        }
        // 重新初始化新页面的播放器
        this.$nextTick(() => {
          this.paginatedExamHouseList.forEach(house => {
            if (house.playUrl) {
              this.playerVides[house.examHouseId] = new EZUIKit.EZUIKitPlayer({
                id: "ezuikit-player-" + house.examHouseId, // 视频容器ID
                accessToken: house.accessToken,
                isCloudRecord: true,
                url: house.playUrl,
                template: 'simple',
              });
            }
          });
        });
      },
      
      /**
       * 转换中控状态为文本
       */
      edgeRunnerStateText(state) {
        switch(state) {
          case 'ONLINE':
            return '在线';
          case 'OFFLINE':
            return '离线';
          case 'ERROR':
            return '异常';
          default:
            return '未知';
        }
      },
    // 查询单位名称
    getCompany(id) {
      this.$post("/sys/company/id", { compId: id }).then((res) => {
        this.compName = res.data.compName;
      });
    },
    async loadExamHouseList() {
        this.loading = true;
        try {
          const res = await this.$post('/biz/isec/exam-house/list', {
          }, 3000, true, 6);
          this.examHouseList = res.data || [];
          // 重置页码
          this.currentPage = 1;
          // 初始化萤石播放器
          this.$nextTick(() => {
            this.paginatedExamHouseList.forEach(house => {
              if (house.playUrl) {
                this.playerVides[house.examHouseId] = new EZUIKit.EZUIKitPlayer({
                  id: "ezuikit-player-" + house.examHouseId, // 视频容器ID
                  accessToken: house.accessToken,
                  isCloudRecord: true,
                  url: house.playUrl,
                  // simple - 极简版; pcLive-pc直播；pcRec-pc回放；mobileLive-移动端直播；mobileRec-移动端回放;security - 安防版;voice-语音版;
                  template: 'simple',
                });
              }
            });
          })
        } catch (error) {
          console.error('Failed to load exam house list:', error);
          this.showMessage('加载失败');
        } finally {
          this.loading = false;
        }
      },

    goToMonitor(examHouse) {
      if (examHouse.examState === '00') {
        this.showMessage('考试仓未开始考试');
        return;
      }
      if (examHouse.houseState === 'OFFLINE') {
        this.showMessage('考试仓已离线');
        return;

      }
      this.$router.push({
        path: '/web/examination/examHouse/examHouseMonitor',
        query: {
          examHouseId: examHouse.examHouseId,
          examAreaId: examHouse.examAreaId,
          examHouseName: examHouse.houseName,
          examState: examHouse.examState
        }
      });
    },

    /**
     * 切换全屏状态
     */
    toggleFullScreen() {
      this.$emit('fullscreen');
    },

    /**
     * 启动10秒刷新定时器
     */
    startRefreshTimer() {
      this.refreshTimer = setInterval(() => {
        this.fetchDataPeriodically();
      }, 10000); // 10秒
    },

    /**
     * 清除刷新定时器
     */
    clearRefreshTimer() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    },

    /**
     * 周期性获取数据的方法
     * 注意：URL和处理逻辑由用户自行实现
     */
    async fetchDataPeriodically() {
        this.loading = true;
        try {
          const res = await this.$post('/biz/isec/exam-house/list', {
            secondQuery: true
          }, 3000, true, 6);
          res.data.forEach(house => {
            this.examHouseList.forEach(item => {
              if (item.examHouseId === house.examHouseId) {
                // 如果变成未考试，则取消取流
                if (house.examState === '00' && item.examState !== '00' && this.playerVides[house.examHouseId]) {
                  this.playerVides[house.examHouseId].stop();
                }
                if (house.examState !== '00' && item.examState === '00' && this.playerVides[house.examHouseId]) {
                  this.playerVides[house.examHouseId].play();
                }
                if (house.examState === '02' && item.examState !== '02') {
                  this.showMessage('考试仓[' + house.houseName + ']告警');
                }
                if (house.houseState === 'OFFLINE' && item.houseState !== 'OFFLINE' && this.playerVides[house.examHouseId]) {
                  this.playerVides[house.examHouseId].stop();
                }
                item.examState = house.examState;
                item.houseState = house.houseState;
                item.edgeRunnerState = house.edgeRunnerState;
                item.edgeRunnerVer = house.edgeRunnerVer;
              }
            })
          })
        } catch (error) {
          console.error('Failed to load exam house list:', error);
          this.showMessage('加载失败');
        } finally {
          this.loading = false;
        }
      },
      showMessage(msg) {
        this.messageBox.message = msg;
        this.messageBox.countdown = this.messageBox.defaultCount;
        document.getElementById('messageDialog').showModal();
        if (!this.messageBox.timer) {
          this.messageBox.timer = setInterval(()=> {
            this.messageBox.countdown--;
            if (this.messageBox.countdown == 0) {
              document.getElementById('messageDialog').close();
              clearInterval(this.messageBox.timer);
              this.messageBox.timer = null;
            }
          }, 1000);  
        }
      }
  },

  mounted() {
    // 设置10秒定时器执行请求
    this.startRefreshTimer();
  },

  beforeDestroy() {
    // 清除定时器
    this.clearRefreshTimer();
  }
};
</script>

<style scoped lang="less">
.exam-house-dashboard {
  padding: 20px 5px;
    background-color: #f5f7fa;
    min-height: 100vh;

  .dashboard-container {
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 20px 10px;
      position: relative;

    .dashboard-header {
      text-align: center;
      margin-bottom: 30px;
      position: relative;

      h2 {
        font-size: 24px;
        color: #333;
        margin: 0;
      }

      .fullscreen-btn {
        position: absolute;
        top: 0;
        right: 0;
        background: #1890ff;
        color: white;
        border: none;
        border-radius: 4px;
        padding: 8px 12px;
        cursor: pointer;
        font-size: 16px;
        transition: background-color 0.3s;

        &:hover {
          background: #40a9ff;
        }
      }
    }

    /* 全屏样式 */
    &:fullscreen,
    &:-webkit-full-screen,
    &:-moz-full-screen,
    &:-ms-fullscreen {
      padding: 40px;
      background-color: #fff;
      z-index: 9999;
    }

    /* 修复全屏时标题样式 */
    &:fullscreen .dashboard-header,
    &:-webkit-full-screen .dashboard-header,
    &:-moz-full-screen .dashboard-header,
    &:-ms-fullscreen .dashboard-header {
      margin-bottom: 40px;
    }

    /* 修复全屏时网格布局 */
    &:fullscreen .exam-house-grid,
    &:-webkit-full-screen .exam-house-grid,
    &:-moz-full-screen .exam-house-grid,
    &:-ms-fullscreen .exam-house-grid {
      grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
      gap: 30px;
    }

    /* 修复全屏时卡片高度 */
    &:fullscreen .exam-house-card-body,
    &:-webkit-full-screen .exam-house-card-body,
    &:-moz-full-screen .exam-house-card-body,
    &:-ms-fullscreen .exam-house-card-body {
      .exam-house-image {
        height: 200px;
      }
    }

    .exam-house-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
      gap: 20px;
      /* 禁止滚轮滚动 */
      overflow: hidden;
      width: 100%;
      margin: 0;
      justify-content: space-between;
    }

    /* 屏幕宽度在1080p及以上时，每行显示4个考试仓 */
    @media (min-width: 1400px) {
      .exam-house-grid {
        grid-template-columns: repeat(4, 1fr);
      }
    }

    /* 全屏样式调整，确保显示8个考试仓 */
    &:fullscreen .exam-house-grid,
    &:-webkit-full-screen .exam-house-grid,
    &:-moz-full-screen .exam-house-grid,
    &:-ms-fullscreen .exam-house-grid {
      grid-template-columns: repeat(4, 1fr);
      gap: 30px;
      width: 100%;
      justify-content: space-between;
    }

      /* 分页控件样式 */
      .pagination-controls {
        margin-top: 20px;
        text-align: center;
      }

    .exam-house-card {
      border: 1px solid #e6e6e6;
      border-radius: 8px;
      overflow: hidden;
      background-color: #fff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
      transition: all 0.3s ease;
      cursor: pointer;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
      }

      .exam-house-card-header {
        background-color: #1890ff;
        color: #fff;
        padding: 12px 16px;

        h3 {
          margin: 0;
          font-size: 16px;
          text-align: center;
        }
      }

      .exam-house-card-header-warn {
        background-color: #f5222d;
        color: #fff;
        padding: 12px 16px;

        h3 {
          margin: 0;
          font-size: 16px;
          text-align: center;
        }
      }

      .exam-house-card-header-gray {
        background-color: #f5f7fa;
        color: #333;
        padding: 12px 16px;

        h3 {
          margin: 0;
          font-size: 16px;
          text-align: center;
        }
      }

      .exam-house-card-body {
        padding: 16px;

        .exam-house-image {
          width: 100%;
          height: 150px;
          overflow: hidden;
          margin-bottom: 16px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .exam-house-alerts {
          .alert-item {
            display: flex;
            align-items: center;
            color: #f5222d;
            margin-bottom: 4px;
            font-size: 12px;

            .alert-icon {
              display: inline-block;
              width: 8px;
              height: 8px;
              background-color: #f5222d;
              border-radius: 50%;
              margin-right: 6px;
            }
          }
        }

        .exam-house-status {
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 12px;
          text-align: center;

          &.normal {
            background-color: #f0f9eb;
            color: #52c41a;
          }
        }
      }

      .exam-house-card-footer {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding: 12px 16px;
        background-color: #fafafa;
        border-top: 1px solid #e6e6e6;
        font-size: 12px;
        color: #666;
        gap: 8px;

        .edge-runner-info {
          flex: 1;
          min-width: 200px;
          text-align: center;
        }

        .view-detail {
          color: #1890ff;
          font-weight: 500;
        }
      }
    }
  }
}
</style>